import ga from "@starter/Framework/Common/GoogleAnalytics";
import { TrackShareWishListParameters } from "@starter/Framework/Common/GoogleAnalytics/trackers/wishList/trackShareWishList";

const useTrackShareWishList = (
    parameters: TrackShareWishListParameters = {},
    options?: Toolkit.GoogleAnalytics.Options,
) => {
    return ga.util.getEventTrackerHook(ga.track.shareWishList, parameters, options);
};

export default useTrackShareWishList;
